import { Component, createContext, useContext, type ReactNode } from "react";

// Context value shape is intentionally `any` during the conversion — Phase 7
// will define a precise IAppContext interface listing all state + setters.
export const AppContext = createContext<any>(null);

interface IAppContextProviderProps {
  children?: ReactNode;
}

class AppContextProvider extends Component<IAppContextProviderProps, any> {
  constructor(props: IAppContextProviderProps) {
    super(props);
    this.state = {
      theme: "LIGHT",
      boarding: "INITIALIZED",
      isFullScreen: false,
      mainLeftNavigationState: "FULL",
      showSearchBar: false,
      tourForceNavExpanded: false,
    };
    this.setTheme = this.setTheme.bind(this);
    this.setBoarding = this.setBoarding.bind(this);
    this.setIsFullScreen = this.setIsFullScreen.bind(this);
    this.setMainLeftNavigationState =
      this.setMainLeftNavigationState.bind(this);
    this.setShowSearchBar = this.setShowSearchBar.bind(this);
    this.setTourForceNavExpanded = this.setTourForceNavExpanded.bind(this);
  }

  setTheme(theme) {
    this.setState({ theme });
  }

  setBoarding(boarding) {
    this.setState({ boarding });
  }

  setMainLeftNavigationState(mainLeftNavigationState) {
    this.setState({ mainLeftNavigationState });
  }

  setShowSearchBar(showSearchBar) {
    this.setState({ showSearchBar });
  }

  setIsFullScreen(isFullScreen) {
    this.setState({ isFullScreen });
  }

  setTourForceNavExpanded(tourForceNavExpanded) {
    this.setState({ tourForceNavExpanded });
  }

  render() {
    return (
      <AppContext.Provider
        value={{
          ...this.state,
          setTheme: this.setTheme,
          setBoarding: this.setBoarding,
          setIsFullScreen: this.setIsFullScreen,
          setMainLeftNavigationState: this.setMainLeftNavigationState,
          setShowSearchBar: this.setShowSearchBar,
          setTourForceNavExpanded: this.setTourForceNavExpanded,
        }}
      >
        {this.props.children}
      </AppContext.Provider>
    );
  }
}

export const useApp = (): any => {
  const context = useContext(AppContext);
  if (!context) throw Error("Context must be not null.");
  return context;
};

export default AppContextProvider;
